(function () {
    'use strict';

    angular.module("imApp").factory("orderStatusesService", ['$ihttp', function ($ihttp) {
        let service = {
            listOrderStatuses: function (parms) {
                return $ihttp.post({
                    method: 2513,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
